import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { analyzeLevelRetentionByTier, analyzLevelRetentionByTierCurrency } from "@/api/dataAll/userSegmentationGrowth";
import { mapState } from 'vuex';
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import retainAllList from './components/retainAllList.vue';
export default {
  name: "userSsegmentationRetention",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  components: {
    retainAllList: retainAllList
  },
  data: function data() {
    return {
      tableData: [],
      deviceList: [// {
      //   label: "新增设备",
      //   id: "device_id"
      // },
      {
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user",
        retention_days: ''
      },
      tableList: [],
      serverList: [],
      // 新增：显示模式
      displayMode: 'both' // both, count, ratio

    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    processTableData: function processTableData(data) {
      var _this2 = this;

      var statusArr = []; //处理表头

      for (var i in data) {
        for (var j in data[i]["retention"]) {
          statusArr.push(j);
        }

        break;
      } // 清空并重新构建表头


      this.tableList = []; // 根据显示模式添加表头

      statusArr.forEach(function (item) {
        if (_this2.displayMode === 'both') {
          _this2.tableList.push({
            label: _this2.$t('dayRetentionCountSlashRatio', {
              day: item
            }),
            prop: "".concat(item, "_count/ratio")
          });
        } else if (_this2.displayMode === 'count') {
          _this2.tableList.push({
            label: _this2.$t('dayRetentionCount', {
              day: item
            }),
            prop: "".concat(item, "_count")
          });
        } else if (_this2.displayMode === 'ratio') {
          _this2.tableList.push({
            label: _this2.$t('dayRetentionRatio', {
              day: item
            }),
            prop: "".concat(item, "_ratio")
          });
        }
      });
      var tableCopyData = JSON.parse(JSON.stringify(data));

      for (var m in tableCopyData) {
        tableCopyData[m]["retentionList"] = {};

        for (var _j in tableCopyData[m]["retention"]) {
          if (this.displayMode === 'both') {
            tableCopyData[m]["retention"]["".concat(_j, "_count/ratio")] = tableCopyData[m]["retention"][_j]["count"] + "/" + tableCopyData[m]["retention"][_j]["ratio"];
          } else if (this.displayMode === 'count') {
            tableCopyData[m]["retention"]["".concat(_j, "_count")] = tableCopyData[m]["retention"][_j]["count"];
          } else if (this.displayMode === 'ratio') {
            tableCopyData[m]["retention"]["".concat(_j, "_ratio")] = tableCopyData[m]["retention"][_j]["ratio"];
          }
        }
      } // 清空表格数据


      this.tableData = [];

      for (var _i in tableCopyData) {
        var rowData = _objectSpread(_objectSpread({}, tableCopyData[_i]["retention"]), {}, {
          level_amount: tableCopyData[_i]["range"],
          new_count: tableCopyData[_i]["new_count"],
          total_recharge: tableCopyData[_i]["total_recharge"]
        });

        this.tableData.push(rowData);
      } // 添加固定的前置列


      this.tableList.unshift({
        label: this.$t('payAmount'),
        prop: 'level_amount',
        desc: this.$t('payAmountRangeDesc')
      }, {
        label: this.$t('newPayPeopleCount'),
        prop: 'new_count'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'total_recharge'
      });
    },
    searchClick: function searchClick() {
      var _this3 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        retention_days: this.paramsData.retention_days
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? analyzLevelRetentionByTierCurrency : analyzeLevelRetentionByTier;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          // 保存原始数据
          // this.rawData = res;
          // 处理表格数据 - 使用当前的displayMode
          _this3.processTableData(res.data);
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {}; // 使用当前的tableList进行导出

      this.tableList.forEach(function (item, index) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    },
    gotoDetailList: function gotoDetailList(row, props) {
      console.log("row==", row, props);

      if (props != "new_count" && props != "total_recharge" && props != "level_amount") {
        var amountRange = row.level_amount.split('-');
        var retainDay = props.replace('_count/ratio', '');
        console.log("retainDay===", retainDay);
        var date = row.date;
        var _this$searchData = this.searchData,
            game_id = _this$searchData.game_id,
            env_id = _this$searchData.env_id,
            special_product_id = _this$searchData.special_product_id,
            server_id = _this$searchData.server_id;
        var query = {
          key: 'userSsegmentationRetention',
          start_date: this.searchData.starttime,
          end_date: this.searchData.endtime,
          min_amount: amountRange[0],
          max_amount: amountRange[1],
          game_id: game_id,
          env_id: env_id,
          special_product_id: special_product_id,
          server_id: server_id,
          retain_day: retainDay
        };
        this.$refs.retainAllList.init(query);
      }
    }
  }
};